"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Client = _interopRequireDefault(require("./Client"));

var _utils = require("./_utils");

/**
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2018 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe Inc. and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe Inc.
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Inc.
 */

/**
 * The Invitations class handles listing invitations for users and creating invitations for a specific resource.
 */
var Invitations = /*#__PURE__*/function () {
  function Invitations() {
    (0, _classCallCheck2["default"])(this, Invitations);
  }

  (0, _createClass2["default"])(Invitations, [{
    key: "confirm",

    /**
     * Request access to a resource shared with the user. 
     * @param {String} resourceUrl - CC Storage path (ID-based only)
     */
    value: function confirm(resourceUrl) {
      if (resourceUrl && resourceUrl.trim() !== '') {
        return _Client["default"].instance.fetch({
          type: 'invitations.confirm',
          urlPath: '/invitations/path/' + (0, _utils.encodeURIComponentEachSubdomain)((0, _utils.getUrlPath)(resourceUrl)),
          method: 'POST',
          returnRaw: true
        });
      }
    }
    /**
     * Create an invitation
     * @param {Object} request
     *   @param {String} request.resourceUrl - CC Storage path (path based or ID-based)
     *   @param {Array} request.recipients - Array of type recipient. The type recipient is composed of the following properties
     *      recipient - is a string which can be of two types:
     *          Email Address:  The valid format for email address is mailto:{emailAddress}
     *          Address Book Entry: Address Book entries can be of two types
     *            1) Address Book Contact: The valid format for an Address Book Contact is an urn string with format- urn:ab:contact:{AddressBookID}-{ContactID}
     *            2) Address Book Group: The valid format for an Address Book Group is an urn string with format- urn:ab:group:{AddressBookID}-{ContactID}
     *   @param {String} request.role - Role to be assigned to the recipients.
     *   @param {String} request.useMounts - Specifies if a mount (aka mount point) to the resource needs to be created for the invitee. This value cannot be TRUE when acceptanceRequired is FALSE
     *   @param {String} request.acceptanceRequired - Specifies if the invitee needs to accept the invitation to collaborate on the resource. When acceptanceRequired is FALSE, the invitee is added as a collaborator on the resource.
     *   @param {Object} request.ansNotification - (Optional - {} to send ANS notification, null to not send ANS notification
     *   @param {Object} request.emailNotification - (Optional - Required if acceptanceRequired is FALSE)
     *      This parameter is a map of Key = notifType (string) and Value = emailTemplate (object)
     *      There are three possible values for the key in the map:
     *      a) acceptance: Email notification when acceptanceRequired is set to TRUE
     *      b) sharing: Email notification when acceptanceRequired is set to FALSE
     *      c) response: (PHASE 2) Email template that will be used to construct the forwarded invitation request for access response email message.
     *                             The template should have conditional parameters so that it can handle both accepted and rejected scenarios.
     *      emailTemplate contains the following template information used to construct the email:
     *        templateName (Required): ID of template registered with APO (Adobe Post Office)
     *        locale (Required): Specifies the locale to be used to select the appropriate template. It is provided in the form of a language code and country code (e.g., “EN_US”)
     *        parameters (Optional): User provided map of key-value pairs needed to construct the template. The list of predefined parameters will be set in the template.
     *   @param {String} request.message - (Optional) A custom message for the inviter to add to the invite notification. The corresponding email param is Param_Custom_Message.
     *   @param {String} request.resourceViewUrl - (Optional) A custom message for the inviter to add to the invite notification. The corresponding email param is Param_Custom_Message.
     *   @param {String} request.captcha - (Optional) This parameter includes the following properties:
     *                   userResponse: (Optional) recaptcha User Response
     *                   siteKey:(Optional) recaptcha Site Key
     * 
     *
     * @return {Promise} A Promise that invites the list of recipients
     *
     * @example
     *  request: {
     *    resourceUrl: "https://cc-api-storage-stage.adobe.io/id/urn:aaid:sc:US:86633ca9-1c6b-4e03-bfa1-3f7c79a6d8f3",
     *    recipients: [
     *      "recipient": "mailto:user@adobe.com",
     *      "recipient": "urn:ab:contact:Address_Book_ABCD:123456",
     *      "recipient": "urn:ab:group:Address_Book_ABCD:123",
     *    ],
     *    role: "editor",
     *    useMounts: true,
     *    acceptanceRequired: true,
     *    ansNotification: {},
     *    emailNotification: {
     *      "acceptance": {
     *        "templateName": "template_name_123",
     *        "parameters": {
     *          "key1": "value1",
     *          "key2": "value2",
     *          "key3": "value3"
     *        },
     *        "locale": "EN_US"
     *      },
     *      "sharing": {
     *        "templateName": "template_name_123",
     *        "parameters": {
     *          "key1": "value1",
     *          "key2": "value2",
     *          "key3": "value3"
     *        },
     *        "locale": "EN_US"
     *      }
     *    },
     *    message : "this is a comment",
     *    captcha: {
     *      "userResponse": "CAPTCHA_USER_RESPONSE_TOKEN",
     *      "siteKey": "CAPTCHA_SITE_KEY"
     *    }
     *  }
     */

  }, {
    key: "create",
    value: function create() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // Changed paramater to accept just an request object so the api is more stable, will not have to
      // worry about paramater ordering and it is easier to give resonable defaults
      var resourceUrl = request.resourceUrl,
          recipients = request.recipients,
          role = request.role,
          useMounts = request.useMounts,
          acceptanceRequired = request.acceptanceRequired,
          ansNotification = request.ansNotification,
          emailNotification = request.emailNotification,
          message = request.message,
          resourceViewUrl = request.resourceViewUrl,
          recaptcha = request.recaptcha;

      if (resourceUrl && resourceUrl.trim() !== '') {
        var notification = {
          ans: ansNotification,
          email: emailNotification,
          parameters: {
            resourceViewUrl: resourceViewUrl,
            message: message
          }
        };
        var body = {
          resourceUrl: (0, _utils.encodeURIComponentCCStorageUrl)(resourceUrl),
          recipients: recipients,
          role: role,
          useMounts: useMounts,
          acceptanceRequired: acceptanceRequired,
          notification: notification,
          captcha: recaptcha
        };
        return _Client["default"].instance.fetch({
          type: 'invitations.create',
          urlPath: '/invitations',
          method: 'POST',
          body: body
        });
      }
    }
    /**
     * Update an invitation
     * @param {String} inviteId - id of the invitation
     * @param {String} role - New role to be assigned to the invitee
     * @returns {Promise} A Promise that updates an invitation
     */

  }, {
    key: "update",
    value: function update(inviteId, role) {
      if (inviteId && role && inviteId.trim() !== '' && role.trim() !== '') {
        var body = {
          role: role
        };
        return _Client["default"].instance.fetch({
          type: 'invitations.update',
          urlPath: '/invitations/' + inviteId,
          method: 'PUT',
          body: body
        });
      }
    }
    /**
     * Delete an invitation
     * @param {String} inviteId - id of the invitation
     * @returns {Promise} A Promise that deletes an invitation
     */

  }, {
    key: "delete",
    value: function _delete(inviteId) {
      if (inviteId && inviteId.trim() !== '') {
        var encodedRequestURI = "/invitations/".concat(encodeURIComponent(inviteId));
        return _Client["default"].instance.fetch({
          type: 'invitations.delete',
          urlPath: encodedRequestURI,
          method: 'DELETE'
        });
      }
    }
    /**
     * Get invitation capabilities for a user
     * @param {String} value - the capability we're looking for
     * @returns {Promise} A Promise that returns a response which headers contain user invitation capabilities
     */

  }, {
    key: "getCapabilities",
    value: function getCapabilities() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'customization';
      return _Client["default"].instance.fetch({
        type: 'invitations.getCapabilities',
        urlPath: '/invitations?capability=' + value,
        method: 'HEAD',
        returnRaw: true
      });
    }
    /**
     * SDK method that parses and determines if invite is disabled, or if UGC (adding messages) to invite creation is disabled.
     * @returns {String} One of the following values: UGC_ENABLED, UGC_DISABLED, INVITE_DISABLED
     */

  }, {
    key: "getInviteCapability",
    value: function getInviteCapability() {
      return this.getCapabilities('customization').then(function (response) {
        if (response.status == 403) {
          return 'INVITE_DISABLED';
        } else if (response.headers && response.headers.get('X-Customization') === false) {
          return 'UGC_DISABLED';
        }

        return 'UGC_ENABLED';
      })["catch"](function (error) {
        // Return enabled if call failed.
        return 'UGC_ENABLED';
      });
    } // TODO

  }, {
    key: "get",
    value: function get() {
      return _Client["default"].instance.fetch({
        type: 'invitations.get',
        urlPath: '/invitations'
      });
    } // TODO

  }, {
    key: "accept",
    value: function accept(inviteId) {
      if (inviteId && inviteId.trim() !== '') {
        return _Client["default"].instance.fetch({
          type: 'invitations.accept',
          urlPath: '/invitations/' + inviteId,
          method: 'POST'
        });
      }
    }
  }, {
    key: "sendVerificationEmail",
    value: function sendVerificationEmail(url) {
      return _Client["default"].instance.fetchRaw(url, 'GET');
    }
  }]);
  return Invitations;
}();
/**
 * Exports the Invitations class.
 */


var _default = Invitations;
exports["default"] = _default;